
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getProjects",
      resolverType: "query",
      routePath: "/getProjects",
      httpMethod: "POST",
    });
  